import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  companyInformationMappings,
  sortableColumnTypes,
  defaultColumnMappings,
  excludedColumns
} from './company_constants';

import TableHeader from 'components/table_header/table_header';
import CompanyColumnSelector from './column_selector';
import { hideOverlayFilters, showOverlayFilters } from '../store/actions/ui';

export class CompaniesTableHeader extends React.Component {
  static propTypes = {
    currentColumns: PropTypes.array.isRequired,
    hideOverlayFilters: PropTypes.func.isRequired,
    includeSearchResults: PropTypes.bool,
    showColumnFilters: PropTypes.bool,
    showOverlayFilters: PropTypes.func.isRequired,
    sort: PropTypes.string,
    onSortChange: PropTypes.func.isRequired
  };

  render() {
    return (
      <TableHeader
        {...this.props}
        defaultColumnMappings={defaultColumnMappings}
        excludedColumns={excludedColumns}
        informationMappings={companyInformationMappings}
        sortableColumnTypes={sortableColumnTypes}
      >
        <CompanyColumnSelector onCancelColumns={this.props.hideOverlayFilters} />
      </TableHeader>
    );
  }
}

const mapStateToProps = state => ({
  currentColumns: state.session.currentColumns,
  showColumnFilters: state.ui.showColumnFilters
});

const mapDispatchToProps = {
  hideOverlayFilters,
  showOverlayFilters
};

export default connect(mapStateToProps, mapDispatchToProps)(CompaniesTableHeader);